"use client";

import { QueryClientProvider as Provider } from "@tanstack/react-query";
import { queryClient } from "../queries/queryClient";
import { ReactNode } from "react";

export function NextClientQueryClientProvider({
  children,
}: {
  children: ReactNode;
}) {
  return <Provider client={queryClient}>{children}</Provider>;
}
